import { BalanceLevel, IBalance } from 'multirpc-sdk';

import { ZERO_STRING } from 'modules/common/constants/const';

import { ChargingModelType } from './types';

export const CREDITS_TO_REQUESTS_RATE = 200;

export const CREDITS_TO_USD_RATE = 10000000;

export const BUNDLE_USAGE_TRESHOLDS = {
  info: 75,
  warning: 50,
  error: 25,
};

export const DEFAULT_PAYG_BALANCE: IBalance = {
  balance: ZERO_STRING,
  balance_ankr: ZERO_STRING,
  balance_credit_ankr: ZERO_STRING,
  balance_credit_usd: ZERO_STRING,
  balance_level: BalanceLevel.RED,
  balance_usd: ZERO_STRING,
  balance_voucher: ZERO_STRING,
};

export const chargigModelTitlesMap: Record<ChargingModelType, string> = {
  deal: 'account.charging-model.deal.title',
  freemium: 'account.charging-model.freemium.title',
  payg: 'account.charging-model.payg.title',
  package: 'account.charging-model.package.title',
  promo: 'account.charging-model.promo.title',
};
